let days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class DateToDayDisplay {
	constructor(dateField, dayDiv) {
		let set = function(dateField, dayDiv) {
			return function(evt) {
				let d = new Date(dateField.value);
				dayDiv.innerHTML = days[d.getDay()];
				return false;
			};
		};
		set = set(dateField, dayDiv);

		dateField.addEventListener('blur', set);
		set();
	}
}

window.DateToDayDisplay = DateToDayDisplay;